export default function Header() {
    return (
        <header>
            <div className="container">
                <div className="header-content">
                    <div className="logo">URL Shortener</div>
                </div>
            </div>
        </header>
    )
}